// Tag names shortened for display.
//
// The charts break a name between its words and never inside one, so a tag of
// several short words needs nothing here - "ternary search" sets as "ternary" /
// "search" on its own. What is listed is only what the wrapping cannot save: a
// single word longer than a line, or a name of more words than there are lines.
// Measured against the narrower of the two charts, the one on a slide, which
// holds about ten characters to a line over two lines.
//
// The full name is still what a tooltip shows.
const TAG_LABELS = {
    'implementation': 'impl.',
    'combinatorics': 'combin.',
    'probabilities': 'probit.',
    'interactive': 'interact.',
    'constructive algorithms': 'construct.',
    'chinese remainder theorem': 'CRT',
    'meet-in-the-middle': 'MITM',
    'string suffix structures': 'suffix struct.'
};

const tagLabel = tag => TAG_LABELS[tag] ?? tag;

export { TAG_LABELS, tagLabel as default };
